import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import DescriptionPopover from "./DescriptionPopover";
import TypographyCell from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";

interface IEmailsRenderCellProps {
	params: GridRenderCellParams;
}

const EmailsRenderCell = (props: IEmailsRenderCellProps) => {
	const { params } = props;
	if (params.value.length < 2) {
		return <TypographyCell params={params} />;
	}
	const moreText = `${params.value?.length - 1} more`;
	const itemsCounter = params.value?.length > 1 ? moreText : "";
	return <DescriptionPopover descriptions={params.value} itemsCounter={itemsCounter} />;
};

export default EmailsRenderCell;
